import { LoaderRow } from "@circle-react/components/shared/LoaderRow";
import InfiniteScroll from "react-infinite-scroll-component";

import { useMemberAreaScrollContainerId } from "@/react/hooks/useMemberAreaScrollContainerId";
import type { Person } from "@/react/types/AudienceList";
import type { CommunityMember as CommunityMemberType } from "@/react/types/CommunityMember";

import { CommunityMember } from "./CommunityMemberWithConnection/CommunityMember";

interface ListViewProps {
  canReceiveDmByMemberId: Record<number, boolean> | false;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  members: CommunityMemberType[];
  shouldShowHiddenMemberTooltip: boolean;
}

export const ListView = ({
  canReceiveDmByMemberId,
  fetchNextPage,
  hasNextPage,
  members,
  shouldShowHiddenMemberTooltip,
}: ListViewProps) => {
  const scrollContainerId = useMemberAreaScrollContainerId();

  return (
    <InfiniteScroll
      style={{ overflow: "initial" }}
      scrollThreshold={0.5}
      next={fetchNextPage}
      hasMore={!!hasNextPage}
      loader={<LoaderRow />}
      dataLength={members.length}
      scrollableTarget={scrollContainerId}
    >
      <ul
        className="flex list-none flex-col gap-y-4"
        data-testid="directory_members_list"
      >
        {members.map((communityMember, index) => (
          <CommunityMember
            communityMember={communityMember as unknown as Person}
            key={communityMember.id}
            shouldShowHiddenMemberTooltip={shouldShowHiddenMemberTooltip}
            isLastItem={index === members.length - 1}
            canReceiveDmFromCurrentMember={
              canReceiveDmByMemberId === false
                ? false
                : (canReceiveDmByMemberId?.[communityMember.id] ?? false)
            }
          />
        ))}
      </ul>
    </InfiniteScroll>
  );
};
